import * as d3 from "d3";

export default function business(){

const businessChart = document.getElementById('chart')
if(businessChart){

  const dataMap = Array.from(document.querySelectorAll("dl")).map(dl => ({
    year: dl.querySelector("dt").textContent.replace(/（.*?）/, ""), // （第◯期）を削除
    count: dl.querySelectorAll("dd").length
  }))

  const data = dataMap.reverse()

  
  const svg = d3.select("#chart");
  const width = +svg.attr("width");
  const height = +svg.attr("height");
  const margin = { top: 30, right: 30, bottom: 80, left: 50 };
  const innerWidth = width - margin.left - margin.right;
  const innerHeight = height - margin.top - margin.bottom;
  
  const g = svg.append("g")
    .attr("transform", `translate(${margin.left},${margin.top})`);
  
  const x = d3.scaleBand()
    .domain(data.map(d => d.year))
    .range([0, innerWidth])
    .padding(0.2);
  
  const y = d3.scaleLinear()
    .domain([0, d3.max(data, d => d.count)])
    .range([innerHeight, 0]);
  
  g.append("g")
    .attr("transform", `translate(0,${innerHeight})`)
    .call(d3.axisBottom(x))
    .selectAll("text")
    .attr("transform", "rotate(-40)")
    .style("text-anchor", "end");
  
  g.append("g").call(d3.axisLeft(y));
  
  g.selectAll("rect")
    .data(data)
    .enter()
    .append("rect")
    .attr("x", d => x(d.year))
    .attr("y", innerHeight)
    .attr("width", x.bandwidth())
    .attr("height", 0)
    .attr("fill", "#65aadd")
    .transition()
    .duration(1000)
    .delay((d, i) => i * 100)
    .attr("y", d => y(d.count))
    .attr("height", d => innerHeight - y(d.count));
  }
}